import { QueryObserverResult, RefetchOptions, useQuery } from 'react-query';
import useApiService from '../utilities/useApiService';
import { formatNdc, isNdcReadyForDrugLookup } from '../utilities/ndc/ndcUtils';
import { useState } from 'react';
import { Product } from '../network/models/ProductInterface';
import { AxiosResponse } from 'axios';
import { QueryHandler } from '../network/models/QueryHandlers';

export const useDrugDetails = (
   handlers?: QueryHandler<Product | undefined, AxiosResponse<any>>
): [
   Product | undefined,
   (ndc: string) => void,
   Omit<QueryObserverResult<Product>, 'data' | 'refetch'>,
   (options?: RefetchOptions) => Promise<QueryObserverResult<Product | undefined>>
] => {
   const { postMethod } = useApiService();
   const [stateNdc, setStateNdc] = useState('');

   const formattedNdc = isNdcReadyForDrugLookup(stateNdc) ? formatNdc(stateNdc) : '';

   const { data, refetch, ...state } = useQuery({
      queryKey: ['/items/fetchDrugDetails', formattedNdc],
      queryFn: (context) => {
         if (handlers?.beforeQuery) handlers?.beforeQuery();
         if (!formattedNdc) return undefined;

         return postMethod<Product>(
            '/items/fetchDrugDetails',
            { ndc: formattedNdc },
            { signal: context.signal }
         );
      },
      enabled: !!formattedNdc,
      onError: handlers?.onError,
      onSuccess: handlers?.onSuccess,
      onSettled: handlers?.onSettled,
      select: (response) => response?.data,
   });

   return [data, setStateNdc, state, refetch];
};
